"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import { Checkbox } from "@/components/ui/checkbox";
type Props = {
  label: string;
  checked: boolean;
  onCheckedChange: () => void;
  /** The value display for the field (pills or text). */
  children: ReactNode;
  /** Optional muted line under the value, e.g. "Currently: 5". */
  caption?: string;
};
export function CheckableFieldRow(t0) {
  const $ = _c(17);
  const {
    label,
    checked,
    onCheckedChange,
    children,
    caption
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="text-base font-semibold text-foreground-heading">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="w-full text-base font-medium md:text-lg">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== caption) {
    t3 = caption && <span className="text-xs text-muted-foreground">{caption}</span>;
    $[4] = caption;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex min-w-0 flex-1 flex-col gap-2">{t1}{t2}{t3}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== checked || $[11] !== label || $[12] !== onCheckedChange) {
    t5 = <div className="mt-1 flex shrink-0 items-center"><Checkbox checked={checked} onCheckedChange={onCheckedChange} className="cursor-pointer" aria-label={label} data-sentry-element="Checkbox" data-sentry-source-file="CheckableFieldRow.tsx" /></div>;
    $[10] = checked;
    $[11] = label;
    $[12] = onCheckedChange;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <label className="flex cursor-pointer items-start justify-between gap-4 py-4" data-sentry-component="CheckableFieldRow" data-sentry-source-file="CheckableFieldRow.tsx">{t4}{t5}</label>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}